export enum CodeAreaKeys {
  head = 'head',
  body = 'body',
  formSubmission = 'formSubmission',
  addToCalendar = 'addToCalendar',
  registerCtaClick = 'registerCtaClick',
  customCtaClick = 'customCtaClick'
}

export type Language = 'javascript' | 'html';

export type ReadOnlyRange = {
  fromLine: number | 'last';
  toLine: number | 'last';
};

export type DocStructure = {
  firstLine: string;
  content: string;
  lastLine: string;
};

export interface CodeAreaConfig {
  title?: string;
  description?: string;
  parametersDescription?: string;
  docStructure: DocStructure;
  doc?: string;
  language: Language;
  readOnlyRanges: ReadOnlyRange[];
  restrictedTags?: string[];
  restrictedKeywords?: string[];
  characterLimit?: number;
  isCustomEvent?: boolean;
}

export interface MarketingTagPayload {
  head_section_script: string;
  body_section_script: string;
  custom_event_script: string;
}

export type MarketingTagLevel = 'organization' | 'event' | 'event_template' | 'series' | 'hub';
